import React from "react";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { Person3, PersonAdd as PersonAddIcon, Close as CloseIcon } from "@mui/icons-material";
import { mobiliTheme } from "../../themes/mobiliTheme";
import useStore from "../../helpers/useStore";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import { PatientMinimalDto } from "../../api-client";

interface PatientColumnTabsProps {
  selectedPatientId?: number;
  openPatients: PatientMinimalDto[];
}

// PatientColumn tabs is not an observer because it does not use any observable data directly
// it does use the stores for actions only
const PatientColumnTabs = ({ selectedPatientId,openPatients }: PatientColumnTabsProps) => {
  const PatientStore = useStore(PatientsContext);
  const {  setSelectedPatientId } = PatientStore;
  const openPatientIds = new Set(openPatients?.map((p) => p.id));
  const normalizedSelectedPatientId =
    selectedPatientId != null
      ? typeof selectedPatientId === "string"
        ? Number(selectedPatientId)
        : selectedPatientId
      : undefined;
  const selectedTabValue =
    normalizedSelectedPatientId != null && openPatientIds.has(normalizedSelectedPatientId)
      ? normalizedSelectedPatientId
      : "neu";

  const onClosePatientTab = (patientId: number) => {
    const tabsAfterClose = PatientStore.openPatients.filter((p) => p.id !== patientId);
    PatientStore.setOpenPatients(PatientStore.openPatients.filter((p) => p.id !== patientId));
    // If the closed tab was the selected one, select another tab
    if (selectedPatientId === patientId) {
      if (tabsAfterClose.length > 0) {
        // Select the tab to the left, or the first tab if none to the left
        setSelectedPatientId(tabsAfterClose[0]?.id);
      }
    }
  };


  return (
    <Grid item xs={12} sx={{ border: "0px dotted green" }}>
      {/* This is the grid for the tabs */}
      <Tabs
        value={selectedTabValue}
        onChange={(event, newValue) =>
          setSelectedPatientId(
            newValue === "neu" ? undefined : typeof newValue === "string" ? Number(newValue) : newValue,
          )
        }
        aria-label="icon label tabs example"
        orientation="horizontal"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: "",
          paddingLeft: mobiliTheme.topLevelPadding,
          "& .MuiButtonBase-root.MuiTabScrollButton-root.MuiTabs-scrollButtons": {
            width: "10px",
          },
        }}
      >
        <Tab
          iconPosition="start"
          icon={<PersonAddIcon />}
          label=""
          value="neu"
          sx={{
            backgroundColor: selectedTabValue === "neu" ? "secondary.main" : "white",
            color: "black",
            padding: "0px 10px 1px 10px",
            minHeight: "40px",
            minWidth: "",
          }}
        />
        {openPatients?.map((patient: PatientMinimalDto, index: any) => (
          <Tab
            key={patient.id}
            iconPosition="start"
            icon={<Person3 />}
            label={
              <Box>
                {`${patient.lastName},${patient.firstName}`}
                <Box
                  component="span"
                  sx={{ zIndex: 4 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClosePatientTab(patient.id);
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                  aria-label="Close"
                  style={{
                    border: "0px solid red",
                    color: mobiliTheme.mainHeader,
                    position: "absolute",
                    backgroundColor: "transparent",
                    right: "-0px",
                    top: "-0px",
                    padding: "1px",
                    cursor: "pointer",
                  }}
                >
                  <CloseIcon sx={{ fontSize: "16px" }} />
                </Box>
              </Box>
            }
            value={patient.id}
          />
        ))}
      </Tabs>
    </Grid>
  );
};

export default PatientColumnTabs;
